<template>
  <main class="main lh-15 bgc-fff c-333 m-a fs-18 ff-as">
    <div class="banner p-r" v-loading="!bannerData.length" v-if="!bannerData.length"></div>
    <client-only v-else>
      <swiper class="banner p-r" :options="swiperOption" ref="bannerSwiper">
        <!-- slides -->
        <swiper-slide v-for="(item, index) in bannerData" :key="index">
          <img :src="item.webUrl" width="100%" height="100%" />
          <div v-show="item.mainTitle" class="banner-text c-fff p-a ta-c">{{ item.mainTitle }}</div>
        </swiper-slide>
        <div class="banner-pagination p-a ta-c" slot="pagination"></div>
      </swiper>
    </client-only>
    <!-- banner:end -->
    <section class="area-1 pl-60 pr-60 bgc-fafafa">
      <h2 class="fs-40 c-000 m-0 d-f ai-c jc-sb">
        {{ $t('common.Industry') }}
        <a href="/industry" class="d-ib fs-0 arrow-icon arrow-icon-000"></a>
      </h2>
      <div class="area-1-content p-r ov-h">
        <div class="p-r swiper-wrapper">
          <div class="area-1-img area-1-img1 swiper-slide">
            <div>
              <a href="/agriculture">
                <img
                  class="lazy-image"
                  src="@/assets/images/index_0526/area_1_11.png"
                  data-original="@/assets/images/index_0526/area_1_11.png"
                  data-m-original="@/assets/images/index_0526/area_1_11_m.jpg"
                  alt=""
                  width="100%"
                  height="auto"
                />
              </a>
              <strong>Precision Agriculture</strong>
            </div>
          </div>
          <div class="area-1-img area-1-img2 swiper-slide">
            <div>
              <a href="/geospatial">
                <img
                  class="lazy-image"
                  src="@/assets/images/index_0526/area_1_12.png"
                  data-original="@/assets/images/index_0526/area_1_12.png"
                  data-m-original="@/assets/images/index_0526/area_1_12_m.jpg"
                  alt=""
                  width="100%"
                  height="auto"
                />
              </a>
              <strong>Geospatial</strong>
            </div>
          </div>
          <div class="area-1-img area-1-img3 swiper-slide">
            <div>
              <a href="/construction">
                <img
                  class="lazy-image"
                  src="@/assets/images/index_0526/area_1_21.png"
                  data-original="@/assets/images/index_0526/area_1_21.png"
                  data-m-original="@/assets/images/index_0526/area_1_21_m.jpg"
                  alt=""
                  width="100%"
                  height="auto"
                />
              </a>
              <strong>Digital Construction</strong>
            </div>
          </div>
          <div class="area-1-img area-1-img4 swiper-slide">
            <div>
              <a href="/electric">
                <img
                  class="lazy-image"
                  src="@/assets/images/index_0526/area_1_22.png"
                  data-original="@/assets/images/index_0526/area_1_22.png"
                  data-m-original="@/assets/images/index_0526/area_1_22_m.jpg"
                  alt=""
                  width="100%"
                  height="auto"
                />
              </a>
              <strong>Electrical</strong>
            </div>
          </div>
        </div>
        <div class="area-1-pagination in-h5"></div>
      </div>
      <!-- <div class="swiper-wrapper p-r">
          <div class="left swiper-slide">
            <div class="p-r">
              <div class="industry-img p-r">
                <a href="/industry" class="d-b bgs-cover"></a>
              </div>
              <div class="text p-a ov-h">
                <h2 class="fs-40 m-0 fw-700">INDUSTRY</h2>
                <div class="c-666 fs-24">Our technology has been widely applied across agriculture, construction, geospatial, electric,etc.</div>
              </div>
            </div>
          </div>
          <div class="right swiper-slide">
            <div class="p-r">
              <div class="consumer-img p-r">
                <a href="//store.fjdynamics.com/" target="_blank" class="d-b bgs-cover"></a>
              </div>
              <div class="text p-a ov-h">
                <h2 class="fs-40 m-0 fw-700">CONSUMER</h2>
                <div class="c-666 fs-24">Start with FJD online store.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="area-1-pagination in-h5"></div> -->
    </section>

    <!-- area-1:end -->
    <section class="area-2 ov-h pb-100 pl-60 pr-60 bgc-fafafa">
      <h2 class="fs-40 c-000 m-0 d-f ai-c jc-sb">
        Customer Case
        <a href="/blog?name=UserCase" class="d-ib fs-0 arrow-icon arrow-icon-000"></a>
      </h2>
      <div class="left f-l">
        <div class="ov-h left-img">
          <a :href="userCaseData[0].url | removeHtml"
            ><img
              class="lazy-image"
              v-lazy="userCaseData[0].detailsImg1"
              data-original="@/assets/images/index_0526/area_2_1.jpg"
              data-m-original="@/assets/images/index_0526/area_2_1_m.jpg"
              width="100%"
              height="100%"
              :alt="userCaseData[0].title"
          /></a>
        </div>
        <div class="text ov-h bgc-fff">
          <div class="fs-20 title ellipsis wlc-2">
            <a class="d-b fw-500" :href="userCaseData[0].url | removeHtml">{{ userCaseData[0].title }}</a>
          </div>
          <div class="fs-16 c-999 date">{{ userCaseData[0].updateTime.slice(0, 11) }}</div>
        </div>
      </div>

      <div class="right f-r d-f fw-w jc-sb">
        <div class="" v-for="item in userCaseData.slice(1)" :key="item.id">
          <div class="right-img ov-h">
            <a :href="item.url | removeHtml"
              ><img
                class="lazy-image"
                data-original="@/assets/images/index_0526/area_2_2.jpg"
                v-lazy="item.detailsImg1"
                width="100%"
                height="100%"
                :alt="item.title"
            /></a>
          </div>
          <div class="text ov-h bgc-fff">
            <div class="fs-20 title ellipsis wlc-2">
              <a class="d-b fw-500" :href="item.url | removeHtml">{{ item.title }}</a>
            </div>
            <div class="fs-16 c-999 date">{{ item.updateTime.slice(0, 11) }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- area-2:end -->
    <section class="area-3 bgc-fafafa ov-h">
      <div class="p-r">
        <div
          class="area-3-img bgs-cover lazy-image"
          data-original="/images/index_0526/area_3.jpg"
          data-m-original="/images/index_0526/area_3_m.jpg"
        ></div>
        <div class="text m-a ov-h bgc-fff p-a">
          <h2 class="m-0 fs-40">About Us</h2>
          <div class="c-666 lh-15">
            FJDynamics is a robotics company focusing on digitization, automation and new energy. At present, our
            technology has been widely applied across precision agriculture, digital construction, geospatial,
            electrical, etc. The company has R&D and operation centers in Singapore, U.S., Sweden, mainland China and
            Hong Kong. With the global reach of our business, we are excited to work with our partners and customers to
            build a better future for our world. We are committed to making useful and affordable robots for the most
            labor-intensive industries, using our technology to drive carbon neutrality and improve the working
            environment.
          </div>
        </div>
      </div>
      <ul class="d-f jc-c ta-c">
        <li class="">
          <i class="d-b m-a">
            <img
              src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23E5E5E5' cx='24' cy='24' r='24'/%3E%3Cpath d='M24 37c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zm8.261-7.862V29c0-1.199 0-1.746-.847-2.23a9.586 9.586 0 0 0-.839-.423c-.477-.217-.793-.359-1.219-.983-.05-.074-.101-.149-.15-.224-.45-.682-.773-1.173-2.005-.978-2.425.384-2.604.81-2.71 1.53l-.018.12c-.157 1.052-.186 1.406.254 1.867 1.644 1.725 2.63 2.97 2.929 3.698.145.354.52 1.43.262 2.493a10.64 10.64 0 0 0 4.096-2.908 6.447 6.447 0 0 0 .247-1.825zM24 13.383a10.589 10.589 0 0 0-7.665 3.27c.23.16.43.386.568.695.266.594.266 1.206.266 1.748 0 .427 0 .832.136 1.125.187.4.996.572 1.71.72.256.055.518.11.757.176.658.182 1.168.773 1.575 1.248.169.196.42.486.546.559.065-.047.274-.275.377-.648.08-.286.057-.538-.059-.676-.728-.858-.688-2.509-.463-3.119.354-.96 1.459-.889 2.268-.837.301.02.585.04.798.012.808-.101 1.058-1.332 1.233-1.573.38-.52 1.542-1.304 2.262-1.787A10.58 10.58 0 0 0 24 13.383z' fill='%23222' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E"
              width="100%"
              height="100%"
              alt="GLOBAL OFFICES"
            />
          </i>
          <countTo
            class="d-b fw-700 count-to"
            id="count-to"
            ref="countTo"
            :autoplay="false"
            :start-val="0"
            :end-val="10"
            :duration="3000"
            is-lazy
          ></countTo>
          <!-- <strong class="d-b fw-700"><b class="motion-number" data-to="10" data-speed="90">0</b></strong> -->
          <span class="d-b fs-26 c-666">Global<br />Offices</span>
        </li>

        <li class="">
          <i class="d-b m-a">
            <img
              src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23E5E5E5' cx='24' cy='24' r='24'/%3E%3Cg fill='%23222'%3E%3Cpath d='M17.429 20.725H30.57v1.138a6.571 6.571 0 0 1-13.142 0v-1.138zM21.536 10.423v1.213A2.46 2.46 0 0 0 24 14.091a2.46 2.46 0 0 0 2.464-2.455v-1.213c2.841 1.01 4.9 3.718 5 6.929l.004.245v.702c.412 0 .746.334.746.746v.026a.747.747 0 0 1-.746.747H16.532a.747.747 0 0 1-.746-.747v-.026c0-.412.334-.746.746-.746v-.702c0-3.317 2.09-6.138 5.004-7.174zM24 10c.42 0 .831.035 1.232.103v1.533l-.005.119A1.23 1.23 0 0 1 24 12.864l-.119-.006a1.23 1.23 0 0 1-1.113-1.222v-1.533c.4-.068.812-.103 1.232-.103z'/%3E%3Cpath d='M30.217 29.121a5.75 5.75 0 0 1 5.283 5.73v1.225a.924.924 0 0 1-.816.918l-.108.006H13.343a.844.844 0 0 1-.836-.738l-.007-.105v-1.304a5.75 5.75 0 0 1 5.283-5.732c.56-.045 1.1-.086 1.618-.121.484 1.57 2.386 2.682 4.599 2.682s4.115-1.111 4.602-2.68c.516.033 1.055.074 1.615.12zm-3.342-1.94l.433 1.73c-.46.871-1.745 1.544-3.308 1.544-1.563 0-2.847-.673-3.308-1.545l.433-1.728h5.75z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
              width="100%"
              height="100%"
              alt="R&D TEAM MEMBERS"
            />
          </i>

          <countTo
            class="d-b fw-700 count-to"
            id="count-to"
            ref="countTo"
            :autoplay="false"
            :start-val="0"
            :end-val="70"
            :duration="1000"
            suffix="%"
            is-lazy
          ></countTo>

          <!-- <strong class="d-b fw-700"><b class="motion-number" data-to="70" data-speed="90">0</b><em>%</em></strong> -->
          <span class="d-b fs-26 c-666">R&D <br />Team Members</span>
        </li>
        <li class="">
          <i class="d-b m-a">
            <img
              src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23E5E5E5' cx='24' cy='24' r='24'/%3E%3Cg fill='%23222' fill-rule='nonzero'%3E%3Cpath d='M19.342 24.01l2.212.002a6.92 6.92 0 0 0 1.803 1.939.525.525 0 0 1-.194.943c-2.597.55-4.525 2.109-5.784 4.677H11c0-3.84 1.88-7.56 8.342-7.56zM20.588 11a5.918 5.918 0 0 1 5.039 2.815c-2.937.798-5.094 3.457-5.094 6.614 0 .872.165 1.706.465 2.474a6.607 6.607 0 0 1-.41.013c-3.277 0-5.93-2.666-5.93-5.958 0-3.292 2.653-5.958 5.93-5.958z'/%3E%3Cpath d='M26.275 27.44v4.843h2.383V27.44C35.058 27.44 37 31.114 37 35H17.933c0-3.84 1.88-7.56 8.342-7.56zm1.246-1.095c-3.276 0-5.93-2.666-5.93-5.958 0-3.292 2.654-5.958 5.93-5.958s5.93 2.666 5.93 5.958c0 3.292-2.654 5.958-5.93 5.958z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
              width="100%"
              height="100%"
              alt="ASSOCIATES WORLDWIDE"
            />
          </i>

          <countTo
            class="d-b fw-700 count-to"
            id="count-to"
            ref="countTo"
            :autoplay="false"
            :start-val="0"
            :end-val="1800"
            :duration="1000"
            suffix="+"
            is-lazy
          ></countTo>

          <!-- <strong class="d-b fw-700"><b class="motion-number" data-to="1800" data-speed="90">0</b><em>+</em></strong> -->
          <span class="d-b fs-26 c-666">Associates<br />Worldwide</span>
        </li>
        <li class="">
          <i class="d-b m-a">
            <img
              src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23E5E5E5' cx='24' cy='24' r='24'/%3E%3Cpath d='M31.31 13c1.012 0 1.832.82 1.832 1.833v8.453c0 4.607-3.437 8.495-8.02 9.072v2.356h5.27c.254 0 .46.205.46.459v1.369a.458.458 0 0 1-.46.458h-12.83a.458.458 0 0 1-.459-.458v-1.37c0-.253.205-.458.458-.458h5.27v-2.356c-4.582-.577-8.02-4.465-8.02-9.072v-8.453c0-1.012.821-1.833 1.834-1.833h14.664zm-17.644 4.8v6.4H13.2A3.2 3.2 0 0 1 10 21v-1.367c0-1.012.82-1.833 1.833-1.833h1.833zm22.5 0c.963 0 1.751.74 1.828 1.683l.006.15V21a3.2 3.2 0 0 1-3.018 3.195l-.182.005h-.466v-6.4h1.833zm-6.46 3.982H28.33v1.371h1.374v-1.371zm0-4.588H28.33v3.657h1.374v-3.657z' fill='%23222' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E"
              width="100%"
              height="100%"
              alt="NATIONAL INVENTION PATENTS"
            />
          </i>

          <countTo
            class="d-b fw-700 count-to"
            id="count-to"
            ref="countTo"
            :autoplay="false"
            :start-val="0"
            :end-val="400"
            :duration="1000"
            suffix="+"
            is-lazy
          ></countTo>
          <!-- <strong class="d-b fw-700"><b class="motion-number" data-to="400" data-speed="90">0</b><em>+</em></strong> -->
          <span class="d-b fs-26 c-666">National<br />Invention Patents</span>
        </li>
      </ul>
    </section>
    <!-- area-3:end -->
    <section class="area-4 pt-100 pb-100 pl-60 pr-60">
      <h2 class="fs-40 c-000 m-0 d-f ai-c jc-sb">
        Company News
        <a href="/blog/?name=CompanyNews" class="d-ib fs-0 arrow-icon arrow-icon-000"></a>
      </h2>
      <ul class="d-f jc-sb">
        <li class="" v-for="item in companyNewsData" :key="item.id">
          <div class="ov-h">
            <a class="fw-500" :href="item.url | removeHtml"
              ><img
                class="lazy-image"
                data-original="@/assets/images/index_0526/area_4_3.jpg"
                v-lazy="item.coverImg"
                width="100%"
                height="100%"
                :alt="item.title"
            /></a>
          </div>
          <div class="title fs-20 ellipsis wlc-2">
            <a class="d-b fw-500" :href="item.url | removeHtml">{{ item.title }}</a>
          </div>
          <div class="news-date d-f jc-sb ai-c fs-16 c-999">
            {{ item.createTime.slice(0, 10) }}
            <a :href="item.url | removeHtml" class="d-ib arrow-icon arrow-icon-000"></a>
          </div>
        </li>
      </ul>
    </section>
    <!-- area-4:end -->
  </main>
</template>

<script>
  // import countTo from 'vue-count-to'
  import { mapGetters } from 'vuex'
  import countTo from '@/components/CountTo'
  import bannerScroll from '@/mixins/bannerScroll.js'
  export default {
    components: {
      countTo
    },
    mixins: [bannerScroll],
    async asyncData({ $api }) {
      try {
        // 公司新闻
        const getCompanyNewsData = $api.blogApi.getBlogs({
          blogCategory: 1,
          isPush: 1,
          languageCode: 'en-US'
        })
        // console.log('[ companyNewsData ] >', companyNewsData)

        // 用户案例
        const getUserCaseData = $api.blogApi.getBlogs({
          blogCategory: 4,
          isPush: 1,
          languageCode: 'en-US'
        })

        const [companyNewsData, userCaseData] = await Promise.allSettled([getCompanyNewsData, getUserCaseData])

        // console.log('[ userCaseData ] >', userCaseData.value.data)
        return {
          companyNewsData: companyNewsData.value.data,
          userCaseData: userCaseData.value.data
        }
      } catch (error) {
        return {
          companyNewsData: [],
          userCaseData: []
        }
      }
    },
    data() {
      return {
        bannerIndex: 0,
        bannerData: [],
        swiperOption: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
          // effect: 'slide',
          // autoplay: {
          //   delay: 4000
          // },
          pagination: {
            el: '.banner-pagination',
            clickable: true
          },
          on: {
            resize() {
              this.update() // 窗口变化时，更新Swiper的一些属性，如宽高等
            }
          }
        }
      }
    },
    head() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org/',
              '@type': 'ItemPage',
              '@graph': [
                {
                  '@type': 'Product',
                  name: 'Trion S1 LiDAR 3D Scanner',
                  url: 'https:/product/trion-s1-3d-lidar-scanner',
                  image: 'https:/images/trion-s1-3d-lidar-scanner/Overview-pic.jpg',
                  description:
                    'FJD Trion S1 LiDAR 3D scanner SLAM-based, high portability: handheld, backpack, drone, car, ship.',
                  brand: {
                    '@type': 'Brand',
                    name: 'FJDynamics'
                  },
                  review: [
                    {
                      '@type': 'Review',
                      reviewBody: 'Easy use with high accuracy.',
                      reviewRating: {
                        '@type': 'Rating',
                        ratingValue: '5',
                        bestRating: '5'
                      },
                      author: {
                        '@type': 'Person',
                        name: 'Huguette'
                      }
                    }
                  ]
                },
                {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: 'https:'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: 'Product',
                      item: 'https:/product'
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: 'Trion S1 LiDAR 3D Scanner'
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters({
        language: 'routerLang'
      })

      // headers0() {
      //   return this.headers.map((header) => Object.assign({}, header, { fixed: false }))
      // },
      // headers2() {
      //   return [{ text: '', fixed: true, width: '100px', sortable: false }].concat(this.headers)
      // },
      // headers3() {
      //   return [{ text: '', fixed: true, width: '100px' }].concat(this.headers)
      // },
      // headers5() {
      //   return this.headers3
      // }
    },
    mounted() {
      this.getBannerData()
    },
    beforeDestroy() {},
    methods: {
      async getBannerData() {
        const { data } = await this.$api.homeApi.getBanners({
          language: this.language,
          launchSeat: 'banners'
        })
        this.bannerData = data
        this.$nextTick(() => {
          const bannerEl = document.getElementsByClassName('banner')[0]
          console.log({ bannerEl })
          this.bannerHeigth = bannerEl['offsetHeight'] + 50
          // console.log(this.bannerHeigth, 'this')
        })
        // console.log(data)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*pc端样式 768px ~  2650px*/
  @media screen and (min-width: 768px) {
    h2 .arrow-icon {
      width: 2.291vw;
      height: 1.198vw;
      margin-top: 0.12rem;
      transition: transform 0.5s;
      will-change: transform;
    }
    .banner {
      height: 8rem;
    }
    .banner-img {
      height: 8rem;
      width: 100%;
    }

    .banner-img-2 {
      background-image: url('@/assets/images/index_0526/banner2.jpg');
    }
    .banner-text {
      top: 6rem;
      left: 1.2rem;
      right: 1.2rem;
      font-size: 0.4rem;
      font-weight: 700;
      text-transform: uppercase;
    }
    .banner-pagination {
      bottom: 0.4rem !important;
      z-index: 3;
    }
    :deep(.swiper-pagination-bullets .swiper-pagination-bullet) {
      height: 2px;
      width: 0.4rem;
      border-radius: 4px;
      opacity: 0.5;
      background-color: #fff;
    }

    :deep(.swiper-pagination-bullets .swiper-pagination-bullet-active) {
      opacity: 1;
    }

    /* area-1 */
    .area-1 {
      padding-top: 0.92rem;
      padding-bottom: 1.12rem;
    }
    .area-1-content {
      height: 8.98rem;
    }
    .area-1 h2 {
      margin-bottom: 2.083vw;
    }
    .area-1-img {
      height: 4.35rem;
      position: absolute;
      overflow: hidden;
    }
    .area-1-img a {
      display: block;
      height: 100%;
    }
    .area-1-img > div strong {
      position: absolute;
      bottom: 0.42rem;
      left: 0.48rem;
      font-size: 0.36rem;
      font-weight: 700;
      color: #fff;
    }
    .area-1-img2 > div strong,
    .area-1-img4 > div strong {
      left: 1.83rem;
    }
    .area-1-img1 > div {
      mask: url('@/assets/images/index_0526/area_1_11.png');
      -webkit-mask: url('@/assets/images/index_0526/area_1_11.png');
      mask-size: cover;
      -webkit-mask-size: cover;
    }
    .area-1-img2 > div {
      mask: url('@/assets/images/index_0526/area_1_12.png');
      -webkit-mask: url('@/assets/images/index_0526/area_1_12.png');
      mask-size: cover;
      -webkit-mask-size: cover;
    }
    .area-1-img3 > div {
      mask: url('@/assets/images/index_0526/area_1_21.png');
      -webkit-mask: url('@/assets/images/index_0526/area_1_21.png');
      mask-size: cover;
      -webkit-mask-size: cover;
    }
    .area-1-img4 > div {
      mask: url('@/assets/images/index_0526/area_1_22.png');
      -webkit-mask: url('@/assets/images/index_0526/area_1_22.png');
      mask-size: cover;
      -webkit-mask-size: cover;
    }
    .area-1-img a img {
      transition: all 0.3s linear;
    }
    .area-1-img:hover a img {
      transform: scale(1.05);
    }
    .area-1-img1,
    .area-1-img4 {
      width: 62.2%;
    }
    .area-1-img2,
    .area-1-img3 {
      width: 45.3%;
    }
    .area-1-img1,
    .area-1-img3 {
      left: 0;
    }
    .area-1-img2,
    .area-1-img4 {
      right: 0;
    }
    .area-1-img3,
    .area-1-img4 {
      top: 4.48rem;
    }

    /* .area-1 .left{width:76.89%}
  .area-1 .left a{ padding-top:34vw;  background-image: url("/images/index_0526/area_1_1.png");}
  .area-1 .right{width:35.22%; position: absolute; top:0; right:0;}
  .area-1 .right a{ padding-top:34vw;  background-image: url("/images/index_0526/area_1_2.png");}
  .area-1 .text{top:4.57rem; width:100%; height:2rem;background-color: #fff;}
  .area-1 .left{left:0}
  .area-1 .left .text h2, .area-1 .left .text div{margin-left:2.864vw; width:55.365vw}
  .area-1 .right{right:0}
  .area-1 h2{margin-bottom:1.04vw;padding-top:1.5vw}
  .area-1 .right .text h2, .area-1 .right .text div{margin-left:5.937vw}
  .area-1 .right .text>div{width:26.041vw}
  .area-1 a{ transition: transform 0.3s ease-out; }
  .area-1 .left:hover a,.area-1  .right:hover a{transform:scale(1.05)}
  .area-1 .left>div{ mask: url("/images/index_0526/area_1_1.png"); -webkit-mask: url("/images/index_0526/area_1_1.png"); mask-size: cover; -webkit-mask-size: cover;}
  .area-1 .right>div{ mask: url("/images/index_0526/area_1_2.png"); -webkit-mask: url("/images/index_0526/area_1_2.png"); mask-size: cover; -webkit-mask-size: cover;} */

    /* area-2 */
    .area-2 h2 {
      margin-bottom: 2.083vw;
    }
    .area-2 .left {
      width: 47.06%;
    }
    .area-2 .right {
      width: 51.22%;
    }
    .area-2 .left .text {
      height: 8.2291vw;
    }
    .area-2 .left-img a {
      display: block;
      font-size: 0;
      height: 7.17rem;
    }
    .area-2 .left .text {
      height: 8.4375vw;
    }
    .area-2 .right > div {
      width: 48.37%;
      margin-bottom: 1.562vw;
      overflow: hidden;
    }
    .area-2 .right .text {
      height: 8.4375vw;
    }
    .area-2 .right-img {
      height: 2.624rem;
    }
    .area-2 .text div {
      padding: 0 1.0937vw;
    }
    .area-2 .text .title {
      margin: 1.262vw 0;
      font-weight: 700;
    }
    .area-2 img {
      transition: transform 0.3s ease-out;
    }
    .area-2 a:hover img {
      transform: scale(1.05);
    }

    /* area-3 */
    .area-3 .text {
      width: 62.29vw;
      padding-bottom: 3.125vw;
      bottom: -1.822vw;
      left: 50%;
      transform: translateX(-50%);
      box-shadow: 0px 6px 29px -4px rgba(0, 0, 0, 0.05);
    }
    .area-3 .text h2,
    .area-3 .text > div {
      margin: 0 2.6vw;
    }
    .area-3 .text h2 {
      padding: 2.08vw 0 1.25vw;
    }
    .area-3-img {
      padding-top: 45.625vw;
      background-image: url('@/assets/images/index_0526/area_3.jpg');
    }
    .area-3 ul {
      padding: 5.723vw 0 4.063vw;
    }
    .area-3 li {
      margin: 0 1.7vw;
      width: 17.073vw;
    }
    .area-3 li i {
      width: 5.208vw;
      height: 5.208vw;
    }
    .area-3 li strong {
      font-size: 60px;
      margin: 1.25vw 0 1.146vw;
    }
    .area-3 li em {
      font-size: 30px;
    }
    .count-to {
      font-size: 60px;
      margin: 1.25vw 0 1.146vw;
      :deep(.count-val) {
        font-weight: 500;
      }
      :deep(.suffix) {
        font-size: 0.3rem;
      }
    }

    count-val ::v-deep(#count-to .suffix) {
      font-size: 30px;
    }

    /* area-4 */
    .area-4 li {
      width: 32.22%;
    }
    .area-4 h2 {
      margin-bottom: 2.083vw;
    }
    .area-4 .title {
      margin: 1.262vw 0;
      font-weight: 600;
    }
    .area-4 li .arrow-icon {
      width: 1.198vw;
      height: 0.625vw;
      margin-left: 0;
      display: none;
    }
    .area-4 img {
      display: block;
      height: 3.45rem;
      transition: transform 0.3s ease-out;
    }
    .area-4 a:hover img {
      transform: scale(1.05);
    }
  }

  /*pc端样式 1650px ~  1920*/
  @media screen and (max-width: 1920px) and (min-width: 1650px) {
    .fs-24 {
      font-size: 20px;
    }
    .area-2 .text .title {
      margin: 1.062vw 0 1.375vw;
    }
  }

  /*pc端样式 1440px ~  1650px*/
  @media screen and (max-width: 1650px) and (min-width: 1440px) {
    .fs-40 {
      font-size: 30px;
    }
    .fs-26 {
      font-size: 20px;
    }
    .fs-24 {
      font-size: 18px;
    }
    .fs-20 {
      font-size: 16px;
    }
    .fs-16 {
      font-size: 14px;
    }
    /* area-3 */
    .area-3 li strong {
      font-size: 40px;
    }
    .area-3 .text > div {
      font-size: 16px;
    }
    .area-3 li i {
      width: 90px;
      height: 90px;
    }
  }

  /*pc端样式 1200px ~  1440px*/
  @media screen and (max-width: 1440px) and (min-width: 1200px) {
    .fs-40 {
      font-size: 26px;
    }
    .fs-26 {
      font-size: 18px;
    }
    .fs-24 {
      font-size: 18px;
    }
    .fs-20 {
      font-size: 16px;
    }
    .fs-16 {
      font-size: 14px;
    }
    /* area-2 */
    .area-2 .text .title {
      margin: 1vw 0;
    }
    /* area-3 */
    .area-3 li strong {
      font-size: 40px;
    }
    .area-3 .text > div {
      font-size: 16px;
    }
    .area-3 li i {
      width: 80px;
      height: 80px;
    }
  }

  /*pc端样式 1366px ~  1024px*/
  @media screen and (max-width: 1366px) and (min-width: 1024px) {
    .fs-24 {
      font-size: 16px;
    }
  }
  /*pc端样式 768px ~  1200px*/
  @media screen and (max-width: 1200px) and (min-width: 768px) {
    .fs-40 {
      font-size: 20px;
    }
    .fs-26 {
      font-size: 16px;
    }
    .fs-24 {
      font-size: 14px;
    }
    .fs-20 {
      font-size: 16px;
    }
    .fs-16 {
      font-size: 14px;
    }
    /* area-1 */
    .area-1 h2 {
      padding-top: 1vw;
      margin-bottom: 0.6vw;
    }
    .area-1 .right .text h2,
    .area-1 .right .text div {
      margin-left: 5vw;
    }
    .area-1 .right .text > div {
      width: 27vw;
    }
    /* area-2 */
    .area-2 .text .title {
      margin: 0.6vw 0;
    }
    /* area-3 */
    .area-3 li strong {
      font-size: 30px;
    }
    .area-3 .text > div {
      font-size: 16px;
    }
    .area-3 li i {
      width: 80px;
      height: 80px;
    }
    .area-3 li span {
      font-size: 18px;
    }
  }
</style>
